import { sort } from "fast-sort";
import { useCustomerStore } from "../../../../../../store/customerStore";
import { customer } from "../../../../../../types/customer";
import StatGroup from "./statGroup";
import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToWindowEdges } from "@dnd-kit/modifiers";
import { useAuthStore } from "../../../../../../store/authStore";
import useCustomerStatUpdate from "../../../../../../hooks/useCustomerStatUpdate";
import { scrollbar } from "../../../../../../classPresets";
import { tab } from "../../../../../../types/common";

interface props {
  customers: customer[];
  tab: tab;
}

export default function Kanban({ customers, tab }: props) {
  const { statuses } = useCustomerStore();
  const statusFilter = (tab.filters.find(f => f.where == "statusId")?.values ||
    []) as number[];

  const selectedStatuses = statuses.filter(s =>
    statusFilter.map(s => Number(s)).includes(s.id)
  );

  const statGropus = sort(statuses)
    .asc("priority")
    .map(status => ({
      status,
      customers: customers.filter(c => c.statusId == status.id),
      selected: selectedStatuses.some(s => s.id == status.id),
    }));

  const sensors = useSensors(
    useSensor(TouchSensor, {
      activationConstraint: { tolerance: 5, delay: 200 },
    }),
    useSensor(MouseSensor, {
      activationConstraint: { distance: 5, delay: 200, tolerance: 20 },
    }),
    useSensor(KeyboardSensor)
  );

  const { user } = useAuthStore();
  const { updateStatus } = useCustomerStatUpdate();

  const handleDragEnd = (event: any) => {
    if (!user) {
      return;
    }

    const { active, over } = event;

    const activeItem = customers.find(c => c.id === active.id);
    const overItem = statuses.find(s => s.id == over?.id);

    if (!activeItem || !overItem) {
      return;
    }

    if (activeItem.statusId == overItem.id) {
      return;
    }

    updateStatus({
      customer: activeItem,
      newStatId: overItem.id,
    });
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      // onDragStart={handleDragStart}
      // onDragCancel={handleDragCancel}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToWindowEdges]}
    >
      <div
        className={`flex min-w-full h-[calc(100dvh)] flex-row gap-4 overflow-x-auto overflow-y-hidden ${scrollbar} p-[1px] px-10`}
      >
        {statGropus.map(group => (
          <StatGroup key={group.status.id} group={group} />
        ))}
      </div>
    </DndContext>
  );
}
